@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.ROLES.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !role) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.ROLES.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout
    titleKey="ADMIN.ROLES.DETAIL.EDIT_TITLE"
    descriptionKey="ADMIN.ROLES.DETAIL.EDIT_DESCRIPTION"
  >
    <app-form-role [payload]="role" [showIntro]="false" [onUpdate]="reload"></app-form-role>
  </app-admin-form-layout>
}
